import type { RevenueReport } from '@witmetrics/utils';
import { MONTHS_SHORT } from '@witmetrics/utils/constants';
import { getReportYear, groupByMonth } from '@/utils/reports';
import type { ReportData } from './types';

export function formatReport(
  currentReport: RevenueReport,
  previousReport: RevenueReport
): ReportData[] {
  const currentYear = getReportYear(currentReport);
  const previousYear = getReportYear(previousReport);
  const currentData = groupByMonth(currentReport);
  const previousData = groupByMonth(previousReport);
  return currentData.map((d, i) => ({
    month: MONTHS_SHORT[i],
    [`${currentYear}`]: d.treatmentAccepted,
    [`${previousYear}`]: previousData[i].treatmentAccepted,
  }));
}
